import React from 'react';
import CRMSettings from '../HR/CRM/CRMSettings';
import './Settings.css';

function CRMConfiguration({ onBack }) {
    return (
        <div className="settings-component-wrapper">
            <CRMSettings onBack={onBack} />
        </div>
    );
}

export default CRMConfiguration;